import { Box } from '@palmetto/palmetto-components';

import EventBy from './EventBy';

export const AllocationCreated = ({ event }: { event: any }) => {
  const allocationName = event?.data?.allocationName ? (
    <Box as="span" display="inline-block" margin="0 2xs 0 0">
      <strong>{event.data.allocationName}</strong> allocation
    </Box>
  ) : (
    'an allocation'
  );

  return (
    <Box display="block">
      <Box as="span" display="inline-block" margin="0 2xs 0 0">
        <EventBy event={event} /> created {allocationName}
      </Box>
    </Box>
  );
};
